module.exports = __webpack_public_path__ + "img/productCode.82aa8837.png";